module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921024151_T.7c45a02e.jpg";